var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"g-item-table-image"},[_c('img',{attrs:{"src":_vm.imageUrl}})])}
var staticRenderFns = []

export { render, staticRenderFns }